import {Injectable} from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';
import {Observable, of, throwError, Subject, Subscription} from 'rxjs';
import {get as _get} from 'lodash';
import * as moment from 'moment';
import {Store, select} from '@ngrx/store';
// import { tokenNotExpired, JwtHelper } from 'angular2-JwtHelper';
import {AppState} from '@app-stores/reducers';
import * as fromAuth from '@app-stores/reducers/auth';
import {AuthActions} from '@app-stores/actions';
import {
	CrmUser, CrmUserRole, CrmLanguage, CrmSuggestedResponse, User, CrmCommunity,
	CrmGroup, CrmTraining, CrmForm, CrmFormCategory, Seeker ,CrmpermissionField
} from '@app-models/index';
import {environment} from '@app-environments/environment';

@Injectable()
export class AppService {
	public crmLanuages: CrmLanguage[] = [];
	public crmUsers: CrmUser[] = [];
	public crmUserRoles: CrmUserRole[] = [];
	// the current suggested response that user selected to see the reviews.
	public crmSuggestedResponse: CrmSuggestedResponse;
	public crmCommunities: CrmCommunity[] = [];
	public crmFormCategories: CrmFormCategory[] = [];
	public users: User[] = [];
	public groups: CrmGroup[] = [];
	public currentLanguage: CrmLanguage;
	public currentGroup: CrmGroup;
	public currentOM: User;
	public currentSeeker: Seeker;
	public currentTraining: CrmTraining;
	public editcurrentTraining: CrmTraining;
	public adminOmMessageUnread: Number = 0;
	public adminMessageUnread: Number = 0;

	public currentStory: any;
	public currentForm: CrmForm;
	public user: CrmUser;
	public accessToken: string;
	public refreshToken: string;
	public expiresIn: number;
	public user$: Observable<CrmUser>;
	public accessToken$: Observable<any>;
	public refreshToken$: Observable<any>;
	public expiresIn$: Observable<any>;
	public setCrmUsersSub = new Subject<CrmUser[]>();
	public setCrmUserRolesSub = new Subject<CrmUserRole[]>();
	public setCrmLanguagesSub = new Subject<CrmLanguage[]>();
	public setCrmCommunitiesSub = new Subject<CrmCommunity[]>();
	public setCrmFormCategoriesSub = new Subject<CrmFormCategory[]>();
	public setUsersSub = new Subject<User[]>();
	public setGroupsSub = new Subject<CrmGroup[]>();
	public setAdminOmMessageUnreadSub = new Subject<Number>();
	public setAdminMessageUnreadSub = new Subject<Number>();

    public current_roles:CrmpermissionField
	constructor(
		public router: Router,
		public store: Store<AppState>,
	) {
		this.user$ = this.store.pipe(select(fromAuth.getUser));
		this.accessToken$ = this.store.pipe(select(fromAuth.getAccessToken));
		this.refreshToken$ = this.store.pipe(select(fromAuth.getRefreshToken));
		this.expiresIn$ = this.store.pipe(select(fromAuth.getExpiresIn));
		this.user$.subscribe(res => {
			this.user = res;
			const language = localStorage.getItem('language');
			if (language) {
				this.currentLanguage = JSON.parse(language);
			}

			if (!res) {
				const accessToken = localStorage.getItem('access_token');
				let token = localStorage.getItem('refresh_token');
				if (token === 'undefined') {
					token = null;
				}

				if (!token && accessToken) {
					token = accessToken;
				}
				if (token) {
					this.store.dispatch(new AuthActions.RefreshToken(token));
				}
			}
		});

		this.accessToken$.subscribe(res => {
			this.accessToken = res;
			if(!this.accessToken){
				this.accessToken = localStorage.getItem('access_token');
			}
		});

		this.expiresIn$.subscribe(res => {
			this.expiresIn = res;
		});

		this.refreshToken$.subscribe(res => {
			if (!environment['test'] && res) {
				setTimeout(() => {
					this.store.dispatch(new AuthActions.RefreshToken(this.refreshToken));
				}, ((3600 * 8) - 5) * 1000);
			}
		});

		this.setCrmUsersSub.subscribe(res => {
			this.crmUsers = res;
		});

		this.setCrmUserRolesSub.subscribe(res => {
			this.crmUserRoles = res;
		});

		this.setCrmLanguagesSub.subscribe(res => {
			this.crmLanuages = res;
		});

		this.setUsersSub.subscribe(res => {
			this.users = res;
		});

		this.setCrmCommunitiesSub.subscribe(res => {
			this.crmCommunities = res;
		});

		this.setGroupsSub.subscribe(res => {
			this.groups = res;
		});

		this.setCrmFormCategoriesSub.subscribe(res => {
			this.crmFormCategories = res;
		});

		this.setAdminOmMessageUnreadSub.subscribe(unreadCount => {
			this.adminOmMessageUnread = unreadCount;
		});
		this.setAdminMessageUnreadSub.subscribe(unreadCount => {
			this.adminMessageUnread = unreadCount;
		});
	}
}
